import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";

const HotBitSection = () => {
  const bidContent = [
    {
      img: "/image/bids/img-1.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.3 ETH",
      subTitle: " Current  Bid",
      content: "1.55 ETH",
      btn: "Place bid",
      likes: "158",
    },
    {
      img: "/image/bids/img-2.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.5 ETH",
      subTitle: " Current  Bid",
      content: "1.65 ETH",
      btn: "Place bid",
      likes: "136",
    },
    {
      img: "/image/bids/img-3.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.8 ETH",
      subTitle: " Current  Bid",
      content: "1.78 ETH",
      btn: "Place bid",
      likes: "250",
    },
    {
      img: "/image/bids/img-4.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.6 ETH",
      subTitle: " Current  Bid",
      content: "1.89 ETH",
      btn: "Place bid",
      likes: "220",
    },
    {
      img: "/image/bids/img-5.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.3 ETH",
      subTitle: " Current  Bid",
      content: "1.89ETH",
      btn: "Place bid",
      likes: "220",
    },
    {
      img: "/image/bids/img-6.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.3 ETH",
      subTitle: " Current  Bid",
      content: "1.55 ETH",
      btn: "Place bid",
      likes: "158",
    },
    {
      img: "/image/bids/img-1.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.3 ETH",
      subTitle: " Current  Bid",
      content: "1.55 ETH",
      btn: "Place bid",
      likes: "158",
    },
    {
      img: "/image/bids/img-2.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.5 ETH",
      subTitle: " Current  Bid",
      content: "1.65 ETH",
      btn: "Place bid",
      likes: "136",
    },
    {
      img: "/image/bids/img-3.jpg",
      ethium: "/image/bids/ethium.svg",
      Title: "ETH Me  Outside",
      ethiumTitle: "1.8 ETH",
      subTitle: " Current  Bid",
      content: "1.78 ETH",
      btn: "Place bid",
      likes: "250",
    },
  ];

  return (
    <div className="bid-section">
      <div className="container">
        <div className="row">
          <h2
            className="text-white mb-5 d-flex align-items-center  justify-content-center"
            data-aos='fade-up'
          >
            <img
              src="/image/bids/logo.png"
              style={{ width: "2rem", height: "auto" }}
              alt=""
            />
            Hot bids
          </h2>

          <Swiper
            slidesPerView={4}
            spaceBetween={20}
            navigation={true}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              572: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }}
            autoplay={{
              delay: 1500,
              disableOnInteraction: false,
            }}
            modules={[Navigation, Autoplay]}
            className="mySwiper"
          >
            {bidContent.map((element, index) => {
              return (
                <SwiperSlide key={index} className="my-5">
                  <div className="bid-card  shadow " data-aos='fade-up'>
                    <img src={element.img} className="main-img" alt="" />
                    <div className="bid-card-content mt-4">
                      <div className="d-flex align-items-center justify-content-between">
                        <h4 className=" text-white">{element.Title}</h4>
                        <span className="text-center ethium-content">
                          <img
                            src={element.ethium}
                            className="ethiumLogo"
                            alt=""
                          />
                          {element.ethiumTitle}
                        </span>
                      </div>
                      <p className="mt-3  mb-4">
                        {element.subTitle}{" "}
                        <span className="text-white"> {element.content}</span>
                      </p>
                      <div className="w-100 d-flex align-items-center justify-content-between">
                        <a href="#" className="bid-btn">
                          {element.btn}
                        </a>
                        <p className="fw-normal mb-0">
                          <i className="fa fa-heart"></i> {element.likes}
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
            {/* <SwiperSlide>Slide 2</SwiperSlide>
        <SwiperSlide>Slide 3</SwiperSlide>
        <SwiperSlide>Slide 4</SwiperSlide> */}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default HotBitSection;
